<template>
  <div class="memberCenter_wrap ChangeInform">
    <div class="nav_pos mb_nav_pos">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <router-link to="/MemberCenter">首页</router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ pageType == 0 ? '企业信息变更申请' : '复评申请' }} </el-breadcrumb-item>
      </el-breadcrumb>
      <div v-if="auditStatus == 1" style="margin-right: 96px" class="back_btn" @click="goToAuditRecord(1)">查看审核进度</div>
      <div class="back_btn" @click="back">
        返回
        <img src="@/assets/img/icon_return.png" alt />
      </div>
    </div>
    <div class="content_wrap">
      <div class="change_inform" v-if="type == 0">
        <div class="title">
          基本信息
          <span v-if="auditStatus == 0" class="span0"> <img src="@/assets/img/icon_tips0.png" />企业信息{{ pageType == 0 ? '变更' : '复评' }}需经广电计量审核通过后，方可生效 </span>
          <span v-if="auditStatus == 1" class="span1"> <img src="@/assets/img/icon_tips1.png" />审核中 </span>
          <span v-if="auditStatus == 2" class="span2"> <img src="@/assets/img/icon_tips2.png" />审核不通过：{{ auditRemark }} </span>
        </div>
        <el-form :inline="true" :model="formInline" :rules="rules" :disabled="auditStatus == 1 ? true : false" class="form_table" ref="ruleForm1" :inline-message="true">
          <el-form-item label="公司全称" prop="SupplierName">
            <el-input v-model="formInline.SupplierName"></el-input>
          </el-form-item>
          <el-form-item label="供应商类别" prop="SupplierCategory">
            <el-select v-model="formInline.SupplierCategory" :disabled="true">
              <el-option :label="item.text" :value="item.value" v-for="(item, index) in formInline.SupplierCategoryList" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="供应商分类：" prop="SupplierType">
            <div>
              <div>
                <el-button icon="el-icon-search" @click.stop="openSupplierTypePage">选择供应商类型</el-button>
              </div>
              <div v-for="(item, index) in formInline.SupplierTypeName" :key="index">{{ item }}</div>
            </div>
          </el-form-item>
          <el-form-item label="公司类型" prop="CompanyType" label-width="150px" ref="CompanyType">
            <el-select v-model="formInline.CompanyType" placeholder="请选择" @change="CompanyTypeFn">
              <el-option v-for="item in formInline.CompanyTypeList" :key="item.value" :label="item.text" :value="item.value" :checked="item.selected"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="统一社会信用代码" prop="SocialCreditCode">
            <el-input v-model="formInline.SocialCreditCode"></el-input>
          </el-form-item>
          <el-form-item label="法定代表人" prop="LegalRepresentative">
            <el-input v-model="formInline.LegalRepresentative"></el-input>
          </el-form-item>

          <el-form-item label="注册资本（万）" prop="RegisteredCapital">
            <el-input v-model="formInline.RegisteredCapital"></el-input>
          </el-form-item>

          <el-form-item label="人数规模" prop="StaffSize">
            <el-select v-model="formInline.StaffSize">
              <el-option :label="item.text" :value="item.value" v-for="(item, index) in formInline.StaffSizeList" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="实缴资本（万）" prop="PaidInCapital">
            <el-input v-model="formInline.PaidInCapital"></el-input>
          </el-form-item>

          <el-form-item label="公司维度：" prop="CompanyDimension">
            <el-select v-model="formInline.CompanyDimension">
              <el-option :label="item.text" :value="item.value" v-for="(item, index) in formInline.CompanyList" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="注册地址：" prop="RegisteredAddress" label-width="180px" class="cascader">
            <el-cascader filterable clearable class="addressCascader" v-model="formInline.RegisteredAddressArr" :options="formInline.AdministrativeAreaList"></el-cascader>
            <el-input placeholder="请输入注册地址" v-model="formInline.RegisteredAddress" class="input-with-select"> </el-input>
          </el-form-item>

          <el-form-item label="办公地址" prop="OfficeAddress">
            <el-cascader filterable clearable class="addressCascader" v-model="formInline.OfficeAddressArr" :options="formInline.AdministrativeAreaList"></el-cascader>
            <el-input placeholder="请输入注册地址" v-model="formInline.OfficeAddress" class="input-with-select"> </el-input>
            <!-- <el-input v-model="formInline.OfficeAddress"></el-input> -->
          </el-form-item>
          <el-form-item label="引入来源：" prop="IntroductionSource" label-width="180px">
            <el-select v-model="formInline.IntroductionSource" class="width_full" placeholder="请选择" @change="IntroductionSourceFn">
              <el-option v-for="item in formInline.IntroductionSourceList" :key="item.value" :label="item.text" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="推荐人：" label-width="180px" prop="Referrer">
            <div style="width: 100%">
              <div style="padding-bottom: 10px">
                <el-input placeholder="请输入推荐人手机" v-model="ReferrerName"></el-input>
                <el-button style="margin-left: 10px" type="primary" @click="querySearchAsync()">查找</el-button>
              </div>
              已选推荐人:
              <div class="name_wrap name_wrap2" v-if="formInline.Referrer != 0">
                <span>{{ formInline.ReferrerName }}|{{ formInline.ReferrerMobile }}</span>
                <i style="cursor: pointer" @click="deleteReferrerName()" class="el-icon-delete"></i>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="供应商性质：" prop="SupplierNature" label-width="180px">
            <el-select v-model="formInline.SupplierNature" class="width_full">
              <el-option :label="item.text" :value="item.value" v-for="(item, index) in formInline.SupplierNatureList" :key="index"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="核心产品：" prop="SupplierProductList" label-width="180px">
            <div style="width: 100%">
              <div style="padding-bottom: 10px">
                <el-select v-model="formInline.SupplierProductList" class="width_full" filterable clearable :multiple="true">
                  <el-option :label="item.ProductName" :value="item.ProductId" v-for="(item, index) in formInline.BaseProductList" :key="index"></el-option>
                </el-select>
              </div>
              <div>
                <el-input class="cascader" v-model="formInline.OtherSupplierProductList" placeholder="填写上面选择框未包含贵司的产品,多个以逗号分隔">
                  <template slot="prepend">自定义添加：</template>
                </el-input>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="核心产品的品牌：" prop="SupplierProductBrandList" label-width="180px">
            <div style="width: 100%">
              <div style="padding-bottom: 10px">
                <el-select v-model="formInline.SupplierProductBrandList" class="width_full" filterable clearable :multiple="true">
                  <el-option :label="item.BrandName" :value="item.BrandId" v-for="(item, index) in formInline.BaseBrandLibrarieList" :key="index"></el-option>
                </el-select>
              </div>
              <div>
                <el-input class="cascader" v-model="formInline.OtherSupplierProductBrandList" placeholder="填写上面选择框未包含贵司的品牌,多个以逗号分隔">
                  <template slot="prepend">自定义添加：</template>
                </el-input>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="经营范围" prop="BusinessScope">
            <el-input v-model="formInline.BusinessScope" type="textarea"></el-input>
          </el-form-item>

          <el-form-item label="纳税人规模" prop="TaxPayerSize" label-width="150px">
            <!-- <el-select v-model="ruleForm.StaffSize" placeholder="请选择" @change="scaleNum"> -->
            <el-select v-model="formInline.TaxPayerSize" placeholder="请选择">
              <el-option v-for="item in formInline.TaxPayerSizeList" :key="item.value" :label="item.text" :value="item.value" :checked="item.selected"></el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item label="邮政编码" prop="PostalCode">
            <el-input v-model="formInline.PostalCode"></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="传真" prop="Fax">
            <el-input v-model="formInline.Fax"></el-input>
          </el-form-item> -->

          <el-form-item label="固定资产(万元)" label-width="150px" prop="FixedAssets">
            <el-input v-model="formInline.FixedAssets" placeholder="请填写固定资产"></el-input>
          </el-form-item>
          <el-form-item label="去年销售总额(万元)" label-width="150px" prop="LastYearTotalSales">
            <el-input v-model="formInline.LastYearTotalSales" placeholder="请填写去年销售总额"></el-input>
          </el-form-item>

          <el-form-item label="生产工人数" label-width="150px" prop="WorkerNumber">
            <el-input type="number" v-model="formInline.WorkerNumber" placeholder="请填写生产工人数"></el-input>
          </el-form-item>
          <el-form-item label="技术人员数" label-width="150px" prop="TechnicianNumber">
            <el-input type="number" v-model="formInline.TechnicianNumber" placeholder="请填写技术人员数"></el-input>
          </el-form-item>
          <!-- <el-form-item label="质管负责人" prop="QualityDirector" label-width="150px">
            <el-input v-model="formInline.QualityDirector" placeholder="请填写质管负责人"></el-input>
          </el-form-item> -->

          <!-- <el-form-item label="质管负责人电话" prop="QualityMobile" label-width="150px">
            <el-input v-model="formInline.QualityMobile" placeholder="请填写质管负责人联系电话"></el-input>
          </el-form-item> -->

          <el-form-item label="质量管理人数" label-width="150px" prop="QualityManagerNumber">
            <el-input type="number" v-model="formInline.QualityManagerNumber" placeholder="请填写质量管理人数"></el-input>
          </el-form-item>
          <el-form-item label="产品检测手段" label-width="150px" prop="ProductTestingMethod">
            <el-input v-model="formInline.ProductTestingMethod" type="textarea" rows="2" placeholder="请填写产品检测手段"> </el-input>
          </el-form-item>
          <!-- <el-form-item label="主要产品或服务" label-width="150px" prop="MajorProject">
            <el-input v-model="formInline.MajorProject" type="textarea" rows="2" placeholder="请填写主要产品或服务"></el-input>
          </el-form-item> -->
          <el-form-item label="售后服务承诺和措施" label-width="150px" prop="AfterSalesService">
            <el-input v-model="formInline.AfterSalesService" type="textarea" rows="2" placeholder="请填写售后服务承诺和措施"> </el-input>
          </el-form-item>

          <el-form-item label="企业信誉" label-width="150px">
            <el-input v-model="formInline.CompanyReputation" type="textarea" rows="2" placeholder="请填写企业信誉"></el-input>
          </el-form-item>
          <el-form-item label="营业期限" prop="BusinessTermDate[0]" label-width="150px" class="businessTermDate rangeDate" v-if="formInline.IsLongBusinessDate">
            <div class="datepicker_wrap">
              <el-date-picker class="filedate filedate1" value-format="yyyy-MM-dd" v-model="formInline.BusinessTermDate[0]" type="date" placeholder="开始日期"></el-date-picker>
            </div>
            <el-checkbox v-model="formInline.IsLongBusinessDate" class="term" @change="longterm">长期</el-checkbox>
          </el-form-item>
          <el-form-item label="营业期限" prop="BusinessTermDate" label-width="150px" class="businessTermDate rangeDate" v-else>
            <el-date-picker v-model="formInline.BusinessTermDate" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" unlink-panels:false></el-date-picker>
            <el-checkbox v-model="formInline.IsLongBusinessDate" class="term" @change="longterm">长期</el-checkbox>
          </el-form-item>

          <el-form-item label="公司简介" prop="CompanyProfile">
            <el-input v-model="formInline.CompanyProfile" type="textarea"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div class="change_inform" v-if="type == 1">
        <div class="title">
          基本信息
          <span v-if="auditStatus == 0" class="span0"> <img src="@/assets/img/icon_tips0.png" />企业信息变更需经广电计量审核通过后，方可生效 </span>
          <span v-if="auditStatus == 1" class="span1"> <img src="@/assets/img/icon_tips1.png" />审核中 </span>
          <span v-if="auditStatus == 2" class="span2"> <img src="@/assets/img/icon_tips2.png" />审核不通过：{{ auditRemark }} </span>
        </div>
        <el-form :inline="true" :model="formInline" :rules="rules" :disabled="auditStatus == 1 ? true : false" ref="ruleForm1" class="form_table" :inline-message="true">
          <el-form-item label="供应商类别" prop="SupplierCategory">
            <el-select v-model="formInline.SupplierCategory" :disabled="true">
              <el-option :label="item.text" :value="item.value" v-for="(item, index) in formInline.SupplierCategoryList" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="姓名" prop="Contact">
            <el-input v-model="formInline.Contact"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="Sex">
            <el-select v-model="formInline.Sex" placeholder="请选择">
              <el-option label="男" :value="false"></el-option>
              <el-option label="女" :value="true"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件类型" prop="CertificateType">
            <el-select v-model="formInline.CertificateType" placeholder="请选择">
              <el-option v-for="item in formInline.CertificateTypeList" :key="item.value" :label="item.text" :value="item.value" :checked="item.selected"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件号码" prop="CertificateNo">
            <el-input v-model="formInline.CertificateNo" placeholder="请填写证件号码"></el-input>
          </el-form-item>
          <el-form-item label="身份证地址" prop="OfficeAddress">
            <el-input v-model="formInline.OfficeAddress" placeholder="请填写身份证地址"></el-input>
          </el-form-item>
          <!-- <el-form-item label="引入来源" prop="IntroductionSource" label-width="150px" ref="IntroductionSource" class="all_line">
            <el-select v-model="formInline.IntroductionSource" placeholder="请选择" >
              <el-option
                v-for="item in formInline.IntroductionSourceList"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="供应商分类：" prop="SupplierType" label-width="180px">
            <div>
              <div>
                <el-button icon="el-icon-search" @click.stop="openSupplierTypePage">选择供应商类型</el-button>
              </div>
              <div v-for="(item, index) in formInline.SupplierTypeName" :key="index">{{ item }}</div>
            </div>
          </el-form-item>
          <el-form-item label="推荐人：" label-width="180px" prop="Referrer">
            <div style="width: 100%">
              <div style="padding-bottom: 10px">
                <el-input placeholder="请输入推荐人手机" v-model="ReferrerName"></el-input>
                <el-button style="margin-left: 10px" type="primary" @click="querySearchAsync()">查找</el-button>
              </div>
              已选推荐人:
              <div class="name_wrap name_wrap2" v-if="formInline.Referrer != 0">
                <span>{{ formInline.ReferrerName }}|{{ formInline.ReferrerMobile }}</span>
                <i style="cursor: pointer" @click="deleteReferrerName()" class="el-icon-delete"></i>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="change_inform">
        <div class="title">银行收款信息</div>
        <el-form :inline="true" :model="formInline" :rules="rules" :disabled="auditStatus == 1 ? true : false" class="form_table" ref="ruleForm2" :inline-message="true">
          <el-form-item label="开户名称" prop="BankAccountName">
            <el-input v-model="formInline.BankAccountName"></el-input>
          </el-form-item>
          <el-form-item label="开户银行" prop="Bank">
            <el-input v-model="formInline.Bank"></el-input>
          </el-form-item>
          <el-form-item label="银行账户" prop="BankAccount">
            <el-input v-model="formInline.BankAccount"></el-input>
          </el-form-item>
          <el-form-item></el-form-item>
          <!-- <el-form-item label="联行号" prop="BankApprovalNumber">
            <el-input v-model="formInline.BankApprovalNumber"></el-input>
          </el-form-item> -->
        </el-form>
      </div>
      <IntellectualPropertyFrom
        v-if="type == 0"
        class="change_inform"
        :IntellectualPropertyList="formInline.IntellectualPropertyList"
        :PropertyStateList="formInline.PropertyStateList"
        :auditStatus="auditStatus == 1 ? false : true"
        ref="IntellectualPropertyFrom"
      />

      <div class="change_inform" v-if="type == 0">
        <div class="title">产品或服务信息</div>
        <div>
          <ProductInfo
            class="form_table tableWrap5_custom"
            :ProductSource="formInline.ProductSource"
            :ProductSourceList="formInline.ProductSourceList"
            :AgentBrandList="formInline.AgentBrandList"
            :auditStatus="auditStatus == 1 ? false : true"
            ref="ProductInfo"
          />
        </div>
      </div>
      <MsgForm class="change_inform" :FileList.sync="FileList" :auditStatus="auditStatus == 1 ? false : true" :TaxPayerSize="formInline.TaxPayerSize" v-if="FileList.length" ref="MsgForm" />
      <SupplierType :tableData="formInline.SupplierTypeTree" :tableData1="formInline.SupplierTypeList" :dialogvisible.sync="dialogvisible" :selectSupplierType.sync="selectSupplierType"></SupplierType>
      <div class="btn_wrap changeInform_btn_wrap">
        <span class="btn_1" v-if="auditStatus == 0 || auditStatus == 2" @click="reflash">重 置</span>
        <span class="btn_1" v-if="auditStatus == 0 || auditStatus == 2" @click="submit">提交申请</span>
        <span class="btn_1" v-if="auditStatus == 1" @click="cancel">撤销申请</span>
      </div>
    </div>
  </div>
</template>

<script>
import MsgForm from '@/components/common/MsgForm'
import ProductInfo from '@/components/common/ProductInfo'
import IntellectualPropertyFrom from '@/components/common/IntellectualPropertyFrom'
import SupplierType from '@/components/common/SupplierType'
import { validateEmail, validatemobile1, validateSocialCreditCode, validContact } from '@/assets/js/util'
export default {
  inject: ['reload'],
  components: {
    MsgForm,
    ProductInfo,
    IntellectualPropertyFrom,
    SupplierType
  },
  data() {
    var validRegisteredAddress = (rule, value, callback) => {
      if (this.formInline.RegisteredAddressArr[0] == null || this.formInline.RegisteredAddress == '') {
        callback(new Error('请填写注册地址'))
      } else {
        // 其他统一的验证逻辑
        callback()
      }
    }
    var validOfficeAddress = (rule, value, callback) => {
      if (this.formInline.OfficeAddressArr[0] == null || this.formInline.OfficeAddress == '') {
        callback(new Error('请填写办公地址'))
      } else {
        // 其他统一的验证逻辑
        callback()
      }
    }
    var validProduct = (rule, value, callback) => {
      if (this.formInline.SupplierProductList.length == 0 && this.formInline.OtherSupplierProductList === '') {
        callback(new Error('请填写核心产品'))
      } else {
        // 其他统一的验证逻辑
        callback()
      }
    }
    return {
      ReferrerName: '',
      selectSupplierType: [],
      dialogvisible: false,
      type: 0,
      auditStatus: 0, //审核状态：0是未申请，1是申请中,2是申请不通过
      FileList: [],
      formInline: {},
      isSupplierOtherType: false,
      socialCreditCode: '',
      certificateNo: '',
      pageType: 0,
      treeprops: {
        label: 'name',
        Child: 'children'
      },
      rules: {
        SupplierType: [{ required: true, message: '请选择供应商类型', trigger: 'blur' }],
        SupplierName: [{ required: true, message: '请输入供应商名称', trigger: 'blur' }],
        SocialCreditCode: [{ required: true, message: '', trigger: 'blur' }],
        LegalRepresentative: [{ required: true, message: '请输入法定代表人', trigger: 'blur' }],
        RegisteredCapital: [{ required: true, message: '请输入注册资本', trigger: 'blur' }],
        StaffSize: [{ required: true, message: '请选择人员规模', trigger: 'change' }],
        BusinessTermDate: [{ required: true, message: '请输入营业期限', trigger: 'change' }],
        BusinessScope: [{ required: true, message: '请输入经营范围', trigger: 'blur' }],
        RegisteredAddress: [{ required: true, message: '请输入注册地址', trigger: 'blur', validator: validRegisteredAddress }],
        SupplierNature: [{ required: true, message: '请选择供应商性质', trigger: 'blur' }],
        SupplierProductList: [{ required: true, validator: validProduct, message: '请选择供核心产品', trigger: 'blur' }],
        OfficeAddress: [{ required: true, message: '请输入办公地址', trigger: 'blur', validator: validOfficeAddress }],
        CompanyProfile: [{ required: true, message: '请输入公司简介', trigger: 'blur' }],
        Contact: [{ required: true, validator: validContact, trigger: 'blur' }],
        CertificateType: [{ required: true, message: '请选择证件类型', trigger: 'change' }],
        CertificateNo: [{ required: true, message: '', trigger: 'blur' }],
        Bank: [{ required: true, message: '请输入开户银行名称', trigger: 'blur' }],
        BankAccount: [{ required: true, message: '请输入开户银行账户', trigger: 'blur' }],
        CompanyType: [{ required: true, message: '请选择公司类型', trigger: 'change' }],
        ContactAddress: [{ required: true, message: '请输入开户银行账户', trigger: 'blur' }],
        SupplierOtherType: [{ required: true, message: '请输入其他供应商类型', trigger: 'blur' }],
        TaxPayerSize: [{ required: true, message: '请选择纳税人规模', trigger: 'blur' }],
        Sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        Email: [{ required: true, validator: validateEmail, trigger: 'blur' }],
        Mobile: [{ required: true, validator: validatemobile1, trigger: 'blur' }],
        QualityDirector: [{ required: true, message: '请填写质管负责人', trigger: 'blur' }],
        QualityMobile: [{ required: true, validator: validatemobile1, trigger: 'blur' }],
        FixedAssets: [{ required: false, message: '请输入固定资产', trigger: 'blur' }],
        LastYearTotalSales: [{ required: true, message: '请输入去年销售总额', trigger: 'blur' }],
        MajorProject: [{ required: true, message: '请填写售后服务承诺和措施', trigger: 'blur' }],
        AfterSalesService: [{ required: true, message: '请填写主要产品或服务', trigger: 'blur' }],
        BankAccountName: [{ required: true, message: '请填写开户名称', trigger: 'blur' }],
        CompanyDimension: [{ required: true, message: '请选择公司维度', trigger: 'blur' }],
        PaidInCapital: [{ required: true, message: '请输入实缴资本', trigger: 'blur' }],
        FixedAssets: [{ required: false, message: '请输入固定资产', trigger: 'blur' }],
        WorkerNumber: [{ required: false, message: '请输入生产工人数', trigger: 'blur' }],
        QualityManagerNumber: [{ required: false, message: '请输入质量管理人数', trigger: 'blur' }],
        TechnicianNumber: [{ required: false, message: '请输入技术人员数', trigger: 'blur' }],
        ReferrerName: [{ required: this.ReferrerNameVaildate, message: '请输入推荐人', trigger: 'blur' }],
        IntroductionSource: [{ required: true, message: '请选择引入来源', trigger: 'blur' }],
        ProductTestingMethod: [{ required: false, message: '请输入产品检测手段', trigger: 'blur' }]
      }
    }
  },
  computed: {
    SocialCreditCode() {
      return this.formInline.SocialCreditCode
    },
    CertificateNo() {
      return this.formInline.CertificateNo
    },
    FixedAssets() {
      return this.formInline.FixedAssets
    },
    RegisteredCapital() {
      return this.formInline.RegisteredCapital
    },
    LastYearTotalSales() {
      return this.formInline.LastYearTotalSales
    },
    ReferrerNameVaildate() {
      return this.formInline.IntroductionSource == '0' ? true : false
    }
  },
  watch: {
    selectSupplierType(newVal, oldVal) {
      var isVaildate = false
      this.formInline.SupplierTypeName = []
      this.formInline.SupplierType = []
      newVal.forEach((item) => {
        this.formInline.SupplierTypeName.push(item.firstName + '-' + item.secondName + '-' + item.supplierTypeName)
        this.formInline.SupplierType.push(item.paramItemCode)
        if (item.paramItemCode.indexOf('GC') >= 0 || item.paramItemCode.indexOf('SP') >= 0) {
          isVaildate = true
        }
      })
      if ((isVaildate = true)) {
        this.rules.FixedAssets[0].required = true
        this.rules.WorkerNumber[0].required = true
        this.rules.QualityManagerNumber[0].required = true
        this.rules.TechnicianNumber[0].required = true
        this.rules.ProductTestingMethod[0].required = true
        this.rules.SupplierProductList[0].required = true
      } else {
        this.rules.FixedAssets[0].required = false
        this.rules.WorkerNumber[0].required = false
        this.rules.QualityManagerNumber[0].required = false
        this.rules.TechnicianNumber[0].required = false
        this.rules.ProductTestingMethod[0].required = false
        this.rules.SupplierProductList[0].required = false
      }
    },
    SocialCreditCode(newVal, oldVal) {
      if (newVal == this.socialCreditCode) {
        delete this.rules.SocialCreditCode[0].validator
      } else {
        this.rules.SocialCreditCode[0].validator = validateSocialCreditCode
      }
    },
    CertificateNo(newVal, oldVal) {
      if (newVal == this.certificateNo) {
        delete this.rules.CertificateNo[0].validator
      } else {
        this.rules.CertificateNo[0].validator = validateSocialCreditCode
      }
    },
    RegisteredCapital(newVal, oldVal) {
      this.formInline.RegisteredCapital = newVal.match(/^\d*(\.?\d{0,3})/g)[0]
    },
    FixedAssets(newVal, oldVal) {
      this.formInline.FixedAssets = newVal.match(/^\d*(\.?\d{0,3})/g)[0]
    },
    LastYearTotalSales(newVal, oldVal) {
      this.formInline.LastYearTotalSales = newVal.match(/^\d*(\.?\d{0,3})/g)[0]
    },
    ReferrerNameVaildate(newVal) {
      this.rules.ReferrerName[0].required = newVal
    }
  },
  mounted() {
    if (this.$route.query.pageType != null) {
      this.pageType = this.$route.query.pageType
      console.log(111)
    }
    console.log(this.pageType)
    this.getList()
  },
  methods: {
    goToAuditRecord(type) {
      this.$router.push({
        path: '/AuditRecord',
        query: {
          pageType: type
        }
      })
    },
    back() {
      this.$router.push('/MemberCenter')
    },
    // handleChange() {
    //   //供应商
    //   if (this.formInline.SupplierType.includes(0)) {
    //     this.isSupplierOtherType = true;
    //   } else {
    //     this.isSupplierOtherType = false;
    //   }
    // },
    getList() {
      this.postRequest('SupplierLogin/SupplierChangeEdit', {}).then((res) => {
        if (res.data.errcode == 0) {
          if (this.pageType == 0) {
            this.auditStatus = res.data.auditState
            this.auditRemark = res.data.auditRemark
          } else {
            this.auditStatus = res.data.reauditState
            this.auditRemark = res.data.reauditRemark
          }

          this.formInline = res.data.data
          this.type = this.formInline.SupplierCategory
          this.socialCreditCode = this.formInline.SocialCreditCode
          this.certificateNo = this.formInline.CertificateNo
          // if (
          //   this.formInline.SupplierOtherType == "" ||
          //   this.formInline.SupplierOtherType == null
          // ) {
          //   this.isSupplierOtherType = false;
          // } else {
          //   this.isSupplierOtherType = true;
          // }
          // this.rules.BusinessTermBeginDate[0].required = !this.formInline.IsLongBusinessDate;
          // this.rules.BusinessTerDate[0].required = !this.formInline
          //   .IsLongBusinessDate;
          this.FileList = this.formInline.FileList1
          // if (this.type === 0) {
          //   this.formInline.SupplierTypeList = this.formInline.SupplierTypeList.filter(
          //     item => {
          //       return item.parentCode == 2 || item.parentCode == 0;
          //     }
          //   );
          // } else if (this.type === 1) {
          //   this.formInline.SupplierTypeList = this.formInline.SupplierTypeList.filter(
          //     item => {
          //       return item.parentCode == 2 || item.parentCode == 1;
          //     }
          //   );
          // }
          this.initData()
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    initData() {
      if (this.formInline.SupplierNature == 0) {
        this.formInline.SupplierNature = ''
      }
      var isVaildate = false
      this.formInline.SupplierType.forEach((item) => {
        if (item.indexOf('GC') >= 0 || item.indexOf('SP') >= 0) {
          isVaildate = true
        }
      })
      if ((isVaildate = true)) {
        this.rules.FixedAssets[0].required = true
        this.rules.WorkerNumber[0].required = true
        this.rules.QualityManagerNumber[0].required = true
        this.rules.TechnicianNumber[0].required = true
        this.rules.ProductTestingMethod[0].required = true
        this.rules.SupplierProductList[0].required = true
      } else {
        this.rules.FixedAssets[0].required = false
        this.rules.WorkerNumber[0].required = false
        this.rules.QualityManagerNumber[0].required = false
        this.rules.TechnicianNumber[0].required = false
        this.rules.ProductTestingMethod[0].required = false
        this.rules.SupplierProductList[0].required = false
      }
    },
    longterm(val) {
      if (val) {
        if (!this.formInline.BusinessTermDate) {
          this.formInline.BusinessTermDate = ['', '']
        }
      } else {
        this.formInline.BusinessTermDate = []
      }
    },
    CompanyTypeFn(val) {
      if (val) {
        this.$refs['CompanyType'].clearValidate()
      }
    },
    cancel() {
      let that = this

      this.getRequest('/SupplierLogin/CancelFlow?pageType=' + this.pageType)
        .then((res) => {
          var data = res.data
          if (data.errcode == 0) {
            this.auditStatus = 0
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    focusError() {
      setTimeout(() => {
        if (document.getElementsByClassName('el-form-item__error').length > 0) {
          // console.log(
          //   document.getElementsByClassName("el-form-item__error")[0]
          // );
          this.$message.error(document.getElementsByClassName('el-form-item__error')[0].innerText)
        }
      }, 500)
    },
    formRule() {
      if (this.type == 1) {
        return new Promise((resolve, reject) => {
          this.$refs.ruleForm1.validate((valid) => {
            if (valid) {
              this.$refs.ruleForm2.validate((valid1) => {
                if (valid1) {
                  resolve(true)
                } else {
                  this.focusError()
                  resolve(false)
                }
              })
            } else {
              this.focusError()
              resolve(false)
            }
          })
        })
      } else {
        return new Promise((resolve, reject) => {
          this.$refs.ruleForm1.validate((valid) => {
            if (valid) {
              this.$refs.ruleForm2.validate((valid1) => {
                if (valid1) {
                  resolve(true)
                } else {
                  this.focusError()
                  resolve(false)
                }
              })
            } else {
              this.focusError()
              resolve(false)
            }
          })
        })
      }
    },

    async submit() {
      let isSubmit = await this.formRule()
      this.$refs.MsgForm.ruleList()
      if (this.type == 0) {
        this.$refs.ProductInfo.ruleList()
        this.$refs.IntellectualPropertyFrom.ruleList()
      }

      let iserror = this.type == 1 ? true : this.$refs.ProductInfo.iserror && this.$refs.IntellectualPropertyFrom.iserror
      if (this.formInline.SupplierType.length == 0) {
        this.$message.error('请选择供应商类型')
        iserror = false
        return false
      }
      if (this.formInline.Referrer == 0 && ((this.type == 0 && this.formInline.IntroductionSource == '0') || this.type == 1)) {
        this.$message.error('请填写推荐人')
        iserror = false
        return false
      }
      // let arr = this.$refs.treerefs.getCheckedKeys();
      // let arr1 = this.$refs.treerefs.getCheckedNodes();
      // if (arr.length == 0) {
      //   this.$message.error("请选择供应商类型");
      //   iserror = false;
      //   return;
      // }
      // arr1.forEach(item => {
      //   if (item.other) {
      //     if (
      //       document.getElementById(item.id).value == "" ||
      //       document.getElementById(item.id).value == null
      //     ) {
      //       this.$message.error("请输入其他供应商类型");
      //       iserror = false;
      //       return;
      //     } else {
      //       item.othervalue = document.getElementById(item.id).value;
      //     }
      //   }
      // });
      // this.formInline.SupplierType = JSON.stringify(arr1);
      this.formInline.PageType = this.pageType

      if (this.$refs.MsgForm.iserror && isSubmit && iserror) {
        if (this.type == 0) {
          this.formInline.ProductSource = this.$refs.ProductInfo.ruleForm.ProductSource
        }
        this.postRequest('SupplierLogin/SupplierChangeApply', {
          fileListJson: JSON.stringify(this.$refs.MsgForm.list),
          baseDataJson: JSON.stringify(this.formInline),
          agentBrandListJson: this.type == 0 ? JSON.stringify(this.$refs.ProductInfo.list) : '',
          intellectualPropertyListJson: this.type == 0 ? JSON.stringify(this.$refs.IntellectualPropertyFrom.PropertyList) : ''
        })
          .then((res) => {
            if (res.data.errcode == 0) {
              this.$message.success('提交成功！')
              this.back()
              this.auditStatus = 1
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },
    reflash() {
      this.reload()
    },
    // renderContent(h, { node, data, store }) {
    //   if (data.other) {
    //     return (
    //       <span class="custom-tree-node">
    //         <span>{node.label}</span>
    //         <input
    //           id={data.id}
    //           value={data.othervalue}
    //           style="height:26px;line-height:26px;margin-left:5px"
    //           class="el-input__inner otherinput"
    //         />
    //       </span>
    //     );
    //   } else {
    //     return (
    //       <span class="custom-tree-node">
    //         <span>{node.label}</span>
    //       </span>
    //     );
    //   }
    // },
    openSupplierTypePage() {
      this.dialogvisible = true
    },
    querySearchAsync() {
      var users = this.formInline.UserList
      const reg = /^1[3-9]{1}[0-9]{9}$/
      var results = this.ReferrerName
        ? users.filter((item) => {
            return item.Mobile1 == this.ReferrerName
          })
        : []
      if (!reg.test(this.ReferrerName)) {
        this.$message.error('请输入正确的推荐人手机号！')
        this.formInline.Referrer = 0
      }
      if (reg.test(this.ReferrerName) && results.length == 0) {
        this.$message.error('供应商入库推荐人的手机号码默认为我司员工在我司系统报备号码，现查无此人，请联系我司对接人员！')
        this.formInline.Referrer = 0
      }
      if (results.length > 0) {
        this.formInline.Referrer = results[0].UserId
        this.formInline.ReferrerName = results[0].UserName
        this.formInline.ReferrerMobile = results[0].Mobile1
      }
    },
    handleSelect(item) {
      this.formInline.Referrer = item.UserId
      this.formInline.ReferrerName = item.UserName
      this.formInline.ReferrerMobile = item.Mobile1
    },
    deleteReferrerName() {
      this.formInline.Referrer = 0
      this.formInline.ReferrerName = ''
      this.formInline.ReferrerMobile = ''
    },
    IntroductionSourceFn(val) {
      if (this.formInline.IntroductionSource == 1) {
        if (this.formInline.SocialCreditCode == '' || this.formInline.SocialCreditCode == null) {
          this.formInline.IntroductionSource = '0'
          this.$message.error('请先输入社会信用代码后选择引入来源')
        }
        this.postRequest('SupplierLogin/ValidateIntroductionSource', {
          socialCreditCode: this.formInline.SocialCreditCode
        }).then((res) => {
          if (res.data.errcode == 0) {
            this.rules.ReferrerName[0].required = false
          } else {
            this.$message.error(res.data.errmsg)
            this.formInline.IntroductionSource = '0'
          }
        })
      } else {
        this.rules.ReferrerName[0].required = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content_wrap {
  padding-bottom: 20px;
  margin-bottom: 20px;
}

.changeInform_btn_wrap {
  width: 366px;
  margin: 40px auto 0;

  .btn_1 {
    background: #055ba9;
    color: #fff;
    border: none;
  }
}

.supplierType {
  .el-form-item {
    display: inline-block;
    flex: 0 0 200px;

    .el-input {
      width: 200px;
    }
  }

  .supplierOtherType {
    ::v-deep.el-form-item__content {
      border-bottom: none;
    }
  }
}

::v-deep.businessTermDate {
  .el-form-item__content {
    align-items: center;
  }

  .term {
    margin-top: 0 !important;
    margin-left: 0 !important;
  }

  .el-input {
    width: 300px;
    margin-right: 8px;
  }

  .businessTermEndDate {
    margin-bottom: 0 !important;

    .el-input {
      width: 100% !important;
    }

    .el-form-item__label:before {
      display: none;
    }

    .el-form-item__content {
      border-bottom: none;
    }
  }
}

::v-deep.el-form-item {
  .el-input.is-disabled .el-input__inner,
  .el-select .el-input.is-disabled .el-input__inner,
  .el-checkbox__input.is-disabled + span.el-checkbox__label,
  .el-textarea.is-disabled .el-textarea__inner {
    color: #606266;
  }
}

.back_btn {
  height: 26px;
  bottom: 7px;
  padding: 0 18px;
  border-radius: 14px;
}

.businessTermDate1 ::v-deep.el-input__inner {
  min-width: 150px !important;
}

.tableWrap5_custom ::v-deep.btn_wrap {
  margin-right: 12px;
  margin-top: 15px;
}

.tableWrap5_custom ::v-deep.tab_wrap5 {
  margin: 0 15px 15px;

  .product_form {
    margin-bottom: 0;
  }

  .table_1 {
    width: 100%;
    margin: 0;
  }

  .table_1 tr td {
    border-right: none;
    border-bottom: none;
  }
}

.change_inform ::v-deep.icon_tips2 {
  vertical-align: middle !important;
}

.rangeDate ::v-deep.el-form-item__content {
  .el-input__inner,
  .el-range-editor {
    width: 300px;
    margin-right: 8px;
    text-align: center;

    .el-range-input {
      font-size: 14px;
    }
  }
}

.tree ::v-deep .el-tree-node {
  .el-tree-node__children {
    white-space: normal;

    .el-tree-node {
      display: inline-block;
    }
  }
}

.otherinput {
  height: 25px;
  line-height: 40px;
  width: 100%;
}

.width_full {
  width: 100% !important;
}
.cascader {
  ::v-deep .el-input-group__prepend {
    padding: unset;
    border: unset;
    border-radius: unset;
  }
}

.name_wrap {
  border: 1px solid #606266;
  margin-left: 11px;
  border-radius: 10px;
  padding: 0 4px;
}

.name_wrap2 {
  display: inline-block;
  padding: 5px;
}
</style>